import { render, staticRenderFns } from "./SimilarProduct.vue?vue&type=template&id=952dbff0"
import script from "./SimilarProduct.vue?vue&type=script&lang=js"
export * from "./SimilarProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports